export const ADMIN = 'admin'
export const BCKS_SUPERADMIN = 'bcks_superadmin'
export const BCKS_ADMIN = 'bcks_admin'
export const BCKS_GTK = 'bcks_gtk'
export const BCKS_DINAS = 'bcks_dinas'
export const BCKS_REGION_PREFIX = 'bcks_region'
export const BCKS_UPT_PREFIX = 'bcks_adminprovinsi'
export const BCKS_BKN = 'bcks_bkn'

export const KEMENDAGRI = 'kemendagri'

// Used to decide Superadmin's active role
export const ROLES_SORTED_BY_PRIORITY: string[] = [
  BCKS_ADMIN,
  BCKS_REGION_PREFIX,
  BCKS_GTK,
  BCKS_UPT_PREFIX,
]

export const ROLES_ALLOWED_LOGIN: string[] = [
  BCKS_SUPERADMIN,
  BCKS_ADMIN,
  BCKS_GTK,
  BCKS_REGION_PREFIX,
  BCKS_UPT_PREFIX,
  KEMENDAGRI,
  BCKS_BKN,
]

export const ROLES_ALLOWED_DEFAULT: string[] = [
  BCKS_SUPERADMIN,
  BCKS_ADMIN,
  BCKS_GTK,
  BCKS_REGION_PREFIX,
  BCKS_UPT_PREFIX,
]

export const ROLES_ALLOWED_CHANGE_REGION: string[] = [
  BCKS_SUPERADMIN,
  BCKS_ADMIN,
  BCKS_GTK,
]

export const ROLES_ALLOWED_ACCESS_DATA_GP: string[] = [BCKS_ADMIN, KEMENDAGRI]

export const ROLES_ALLOWED_USER_MANAGEMENT: string[] = [
  BCKS_ADMIN,
  BCKS_UPT_PREFIX,
]

export const ROLES_ALLOWED_LAPOR_KEMENDAGRI: string[] = [BCKS_REGION_PREFIX]

export const ROLES_ALLOWED_GET_LAPORAN_KEMENDAGRI: string[] = [
  BCKS_ADMIN,
  BCKS_GTK,
  KEMENDAGRI,
]

export const ROLE_DETAILS = [
  {
    key: BCKS_REGION_PREFIX,
    name: 'Dinas',
    description: 'Dinas Pendidikan Provinsi atau Kabupaten/Kota',
  },
  {
    key: BCKS_UPT_PREFIX,
    name: 'UPT',
    description: 'Unit Pelaksana Teknis',
  },
  {
    key: BCKS_ADMIN,
    name: 'Admin',
    description: 'Administrator Sistem',
  },
  {
    key: BCKS_GTK,
    name: 'GTK',
    description: 'Guru dan Tenaga Kependidikan',
  },
]

const roles = {
  BCKS_SUPERADMIN,
  BCKS_ADMIN,
  BCKS_GTK,
  BCKS_REGION_PREFIX,
  BCKS_UPT_PREFIX,
  KEMENDAGRI,
}

export default roles
